import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo/logo-camp-azul-horizontal.png'


const _withScopeId = n => (_pushScopeId("data-v-301aca9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 rounded d-flex flex-column justify-content-between bg-wither p-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center flex-column align-items-center gap-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo user indicar",
    style: {"width":"300px","margin-top":"100px"}
  }),
  /*#__PURE__*/_createElementVNode("h1", { style: {"text-align":"center","max-width":"300px"} }, "Gestão de tickets e suporte ao cliente")
], -1))
const _hoisted_3 = { class: "fv-row mb-6" }
const _hoisted_4 = { class: "input-label" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-2" }, "E-mail", -1))
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "fv-row mb-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, null, -1))
const _hoisted_10 = { class: "input-label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-2" }, "Senha", -1))
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "form-check form-check-sm form-check-custom form-check-solid mb-10" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label text-muted fs-6",
  for: "rememberme"
}, " Lembrar ", -1))
const _hoisted_16 = { class: "d-grid gap-2 text-left" }
const _hoisted_17 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn background_btn_1 text-white mb-5"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Acessar ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "d-flex justify-content-between px-10" }
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "images/ios.png",
  alt: "",
  style: {"width":"100px"}
}, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "images/android.png",
  alt: "",
  style: {"width":"100px"}
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "copy" }, "Copyright ©Camp Tecnologia", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_Form, {
      class: "form w-100 px-10",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Field, {
              class: "form-control",
              type: "text",
              name: "email",
              placeholder: "E-mail"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ErrorMessage, { name: "email" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("label", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg",
              type: "password",
              name: "password",
              autocomplete: "off",
              placeholder: "Senha"
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "1",
            "data-kt-check": "true",
            id: "rememberme",
            name: "rememberme",
            "data-kt-check-target": "rememberme",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.remember) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.remember]
          ]),
          _hoisted_15
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", _hoisted_17, _hoisted_20, 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          href: _ctx.linkIOS,
          target: "_blank",
          class: "me-2"
        }, _hoisted_24, 8, _hoisted_22),
        _createElementVNode("a", {
          href: _ctx.linkAndroid,
          target: "_blank"
        }, _hoisted_27, 8, _hoisted_25)
      ]),
      _hoisted_28
    ])
  ])), [
    [
      _directive_loading,
      _ctx.fullscreenLoading,
      void 0,
      {
        fullscreen: true,
        lock: true
      }
    ]
  ])
}